import { render, staticRenderFns } from "./carStopNengBrand.vue?vue&type=template&id=ab70c13e&scoped=true"
import script from "./carStopNengBrand.vue?vue&type=script&lang=js"
export * from "./carStopNengBrand.vue?vue&type=script&lang=js"
import style0 from "./carStopNengBrand.vue?vue&type=style&index=0&id=ab70c13e&prod&lang=stylus&scoped=true"
import style1 from "./carStopNengBrand.vue?vue&type=style&index=1&id=ab70c13e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab70c13e",
  null
  
)

export default component.exports